// extracted by mini-css-extract-plugin
module.exports = {"sliderIndicator":"SliderIndicator_sliderIndicator__G_ZA1","fadeIn":"SliderIndicator_fadeIn__jPrno","hidden":"SliderIndicator_hidden__5axhr"};